import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

import { AnnotationsService } from '../../services/annotations.service';
import { CommentsService } from '../../services/comments.service';
import { MenuOptionsService } from '../../services/menu-options.service';
import { PlotsService } from '../../services/plots.service';

import { CommentDialogComponent } from './comment-dialog.component';

/** Component for setting filters on the plot data */
@Component({
    selector: 'sci-comment-bar',
    templateUrl: './comment-bar.component.html',
    styleUrls: [ './comment-bar.component.scss' ]
})
export class CommentBarComponent implements OnInit {
    @Input() plotId: string;
    enableComments = true;
    hideComments = false;
    hideWhenEmpty = true;
    comments: string[][] = [];

    constructor(
        private _commentsService: CommentsService,
        private _dialog: MatDialog,
        private _annotationsService: AnnotationsService,
        private _plotsService: PlotsService,
        private _menuOptionsService: MenuOptionsService
    ) {}

    ngOnInit() {
        this._commentsService.getPlotComments$( this.plotId ).subscribe( commentMap => {
            const newComments = Array.from( commentMap.entries() );

            // remove comments for annotations that have been removed
            this.comments.forEach( ( comment, index ) => {
                if ( !newComments.find( newComment => 'palette-color-' + newComment[0] === comment[0] ) ) {
                    this.comments.splice( index );
                }
            });

            // add new comments
            newComments.forEach( ( comment, index ) => {
                if ( !this.comments[ index ] ) { this.comments[ index ] = []; }
                this.comments[ index ][0] = 'palette-color-' + comment[0];
                this.comments[ index ][1] = comment[1];
                this.comments[ index ][2] = ( comment[1] === '' ) ? 'no-comment' : 'full-width';
            });

            // If 1+ comments have content, expand them and collapse empty comments
            if ( this.comments.every( comment => comment[1] === '' ) ) {
                this.comments.forEach( comment => comment[2] = 'full-width' );
            }
            this.shouldHideComments();
        });

        this._menuOptionsService.getMenuOptions$( this.plotId ).subscribe( newMenuOptions => {
            if ( this.enableComments !== newMenuOptions.annotations.show
                || this.hideWhenEmpty !== newMenuOptions.comments.hideWhenEmpty ) {
                this.enableComments = newMenuOptions.annotations.show;
                this.hideWhenEmpty = newMenuOptions.comments.hideWhenEmpty;
                this.shouldHideComments();
            }
        });
    }

    /** determine if we should hide the comments or not */
    shouldHideComments(): void {
        const numberOfAnnotations = this._annotationsService.getNumberOfAnnotations( this.plotId );
        if ( numberOfAnnotations === 0 && this.hideWhenEmpty ) {
            this.hideComments = true;
        } else {
            this.hideComments = false;
        }
        this._plotsService.reflowPlots();
    }

    updateComment( newComment: string[] ) {
        this._commentsService.setPlotComment( this.plotId, newComment[0].slice(14), newComment[1] );
    }

    openCommentModal() {
        this._dialog.open( CommentDialogComponent, {
            autoFocus: false,
            data: this.plotId,
            width: '75%'
        });
    }
}
